import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import FontIcon from './common/FontIcon';
import './AddAppItem.css';
import languageManager from '../utils/languageManager';

/**
 * 添加应用按钮组件
 * 支持紧凑和详情两种显示模式
 */
const AddAppItem = ({ onClick, iconSize = 64, iconRadius = 12, iconTextColor = '#ffffff' }) => {
  // 获取显示模式状态
  const { websiteDisplayMode } = useSelector(state => state.settings);
  
  // 语言刷新状态
  const [languageKey, setLanguageKey] = useState(0);
  
  // 监听语言变更
  useEffect(() => {
    const handleLanguageChange = () => {
      setLanguageKey(prev => prev + 1);
    };
    
    // 注册语言变更监听器，返回取消监听的函数
    const unsubscribe = languageManager.addListener(handleLanguageChange);
    
    return unsubscribe;
  }, []);
  
  // 在详情模式下使用更大的图标
  const detailedIconSize = Math.max(iconSize * 0.7, 32);
  
  // 紧凑模式的内容
  const CompactContent = () => (
    <>
      <div 
        className="add-icon"
        style={{
          width: `${iconSize}px`,
          height: `${iconSize}px`,
          borderRadius: `${iconRadius}px`
        }}
      >
        <FontIcon 
          name="plus" 
          size={`${Math.round(iconSize * 0.375)}px`} 
          style={{color: iconTextColor}} 
        />
      </div>
      <div className="add-title" style={{color: iconTextColor}} key={languageKey}>
        {languageManager.t('common.addNavigation')}
      </div>
    </>
  );

  // 详情模式的内容
  const DetailedContent = () => (
    <>
      <div 
        className="add-icon"
        style={{
          width: `${detailedIconSize}px`,
          height: `${detailedIconSize}px`,
          borderRadius: `${iconRadius}px`,
          border: '2px dashed rgba(255, 255, 255, 0.3)',
          backgroundColor: 'rgba(255, 255, 255, 0.1)'
        }}
      >
        <FontIcon 
          name="plus" 
          size={`${Math.round(detailedIconSize * 0.375)}px`} 
          style={{color: iconTextColor}} 
        />
      </div>
      <div 
        className="add-content"
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          flex: 1,
          minWidth: 0,
          paddingLeft: '4px'
        }}
      >
        <div 
          className="add-title" 
          style={{
            color: iconTextColor,
            fontSize: "13px",
            fontWeight: 600,
            lineHeight: '1.4'
          }}
          key={languageKey}
        >
          {languageManager.t('common.addNavigation')}
        </div>
      </div>
    </>
  );

  return (
    <div 
      className="app-item"
      style={{
        width: websiteDisplayMode === 'detailed' ? `${iconSize + 100}px` : `${iconSize + 15}px`,
        cursor: 'pointer'
      }}
    >
      <div 
        className={`add-app-item ${websiteDisplayMode}`}
        onClick={onClick} 
      >
        {websiteDisplayMode === 'detailed' ? <DetailedContent /> : <CompactContent />}
      </div>
    </div>
  );
};

export default AddAppItem; 